module.exports = __webpack_public_path__ + "img/3.9694bc09.png";